<template>
  <v-autocomplete
    chips
    :items="itemsValue"
    :label="'Pick your classification (required)'"
    hint="Pick your classification"
    item-text="name"
    item-value="id"
    menu-props="auto"
    persistent-hint
    v-model="classificationId"
  >
  </v-autocomplete>
</template>
<script>
export default {
  name: 'AttributeClassificationNative',
  props: {
    value: {
      type: [Number, Object],
      default: () => false,
    },
  },
  data: () => ({
    type: 'classification',
    classificationId: null,
  }),
  mounted() {
    this.classificationId = this.value;
  },
  computed: {
    itemsValue() {
      return this.$store.getters['classification/classifications'];
    },
  },
  watch: {
    classificationId() {
      this.$emit('input', this.classificationId);
    },
  },
};
</script>
